import { applyMiddleware, compose, createStore } from 'redux';
import reducers from '../reducers/index';
import createHistory from 'history/createHashHistory';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';
import createSocketIoMiddleware from 'redux-socket.io';
import io from 'socket.io-client';
import { routerMiddleware } from 'react-router-redux';
import authTokenMiddleware from './middleware';

const history = createHistory();
const routeMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

// Nur für Testumgebung
// const socket = io('http://localhost:3005');
// / Nur für Testumgebung

const socket = io('https://bgbau.leanact.de/', { path: '/api/socket.io' });

// Socket.io Middleware einbinden
const socketIoMiddleware = createSocketIoMiddleware(socket, 'server/', {
    execute: authTokenMiddleware
});
//Redux Devtools einbinden
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Redux store konfigurieren
export default function configureStore(initialState) {
    const middlewares = socket.hasListeners('action') ? [sagaMiddleware, routeMiddleware] : [sagaMiddleware, routeMiddleware, socketIoMiddleware];

    const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(...middlewares)));

    sagaMiddleware.run(rootSaga);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/index', () => {
            const nextRootReducer = require('../reducers/index');
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}

export { history };



// WEBPACK FOOTER //
// ./store/index.js